import { DingdingOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { Button, App, Form, Input, Modal, Alert } from 'antd';
import { useState } from 'react';
import type { CurrentUser } from '@mori/contracts';
import { post } from '../api';
import { BRAND, BrandMark } from '../brand';

export function LoginPage({ onLogin }: { onLogin: (user: CurrentUser) => void }) {
  const { message } = App.useApp();
  const [loading, setLoading] = useState(false);
  const [localOpen, setLocalOpen] = useState(false);
  const [loginError, setLoginError] = useState('');
  const passwordLogin = async (values: { username: string; password: string }) => {
    setLoading(true);
    setLoginError('');
    try { const result = await post<{ user: CurrentUser }>('/auth/login', values); message.success('登录成功'); onLogin(result.user); }
    catch (error) { setLoginError(error instanceof Error ? error.message : '登录失败'); }
    finally { setLoading(false); }
  };
  return <main className="login-page">
    <section className="login-story" aria-label="设备全生命周期管理入口">
      <div className="login-grid" />
      <div className="login-brand"><BrandMark size={38}/><div><strong>{BRAND.companyName}</strong><span>{BRAND.englishName}</span></div></div>
      <div className="login-copy">
        <p className="login-kicker"><span/>设备管理中枢</p>
        <h1>让设备管理<br/><span>更规范、更高效</span></h1>
        <p className="login-description">连接点检、保养、维修与备件数据，为设备全生命周期提供统一、可靠的管理入口。</p>
        <div className="login-capabilities"><span><b>01</b> 设备点检</span><span><b>02</b> 设备保养</span><span><b>03</b> 设备维修</span></div>
      </div>
    </section>
    <section className="login-auth" aria-label="企业身份认证">
      <div className="auth-card">
        <p className="auth-eyebrow">企业身份认证</p>
        <h2>{BRAND.systemName}</h2>
        <Button type="primary" size="large" block icon={<DingdingOutlined/>} onClick={() => message.info('钉钉登录暂未配置，请使用下方的管理员账号登录')}>使用钉钉登录</Button>
        <p className="auth-trust"><SafetyCertificateOutlined/> 仅限企业授权人员访问</p>
        <div className="auth-separator" />
        <Button className="admin-entry" type="text" onClick={() => { setLoginError(''); setLocalOpen(true); }}>管理员账号登录 <span aria-hidden="true">→</span></Button>
      </div>
      <footer>© 2026 {BRAND.companyName}</footer>
    </section>
    <Modal title="管理员账号登录" width={400} open={localOpen} footer={null} destroyOnHidden onCancel={() => { if (!loading) setLocalOpen(false); }}>
        <p>请输入已开通的管理员账号和密码。</p>
        {loginError && <Alert type="error" title={loginError} showIcon style={{ marginBottom: 16 }} />}
        <Form layout="vertical" onFinish={passwordLogin} requiredMark={false}>
          <Form.Item label="账号" name="username" rules={[{ required: true, whitespace: true, message: '请输入账号' }]}>
            <Input size="large" autoComplete="username" placeholder="请输入账号" />
          </Form.Item>
          <Form.Item label="密码" name="password" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password size="large" autoComplete="current-password" placeholder="请输入密码" />
          </Form.Item>
          <Button type="primary" size="large" block htmlType="submit" loading={loading}>登录系统</Button>
        </Form>
    </Modal>
  </main>;
}
